import type { CurrencyCode } from "@beautypie/core";

export const isCurrencyCode = (currency: string): currency is CurrencyCode =>
  ["GBP", "USD"].includes(currency);
